import { render, staticRenderFns } from "./lab_sel.vue?vue&type=template&id=5a4e9fd3&scoped=true"
import script from "./lab_sel.vue?vue&type=script&lang=js"
export * from "./lab_sel.vue?vue&type=script&lang=js"
import style0 from "./lab_sel.vue?vue&type=style&index=0&id=5a4e9fd3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4e9fd3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\2026\\Halov2-Fishery-Upgrade\\halov-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4e9fd3')) {
      api.createRecord('5a4e9fd3', component.options)
    } else {
      api.reload('5a4e9fd3', component.options)
    }
    module.hot.accept("./lab_sel.vue?vue&type=template&id=5a4e9fd3&scoped=true", function () {
      api.rerender('5a4e9fd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/org/lab_sel.vue"
export default component.exports